import { push } from 'connected-react-router';
import { AlertHandler } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';

import { actionCreators as authActions } from 'redux/authHandlers';
import { DEFAULT_ROUTES, ROUTES, RESTRICTED_ROUTES, PUBLIC_ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

const DEFAULT = appConfig.DEFAULT_ROUTES || DEFAULT_ROUTES;
const RESTRICTED = appConfig.RESTRICTED_ROUTES || RESTRICTED_ROUTES;

export const navigateToDefaultRoute = (dispatch, getState) => {
  const { currentUser } = getState().auth;
  if (currentUser) {
    dispatch(push(DEFAULT.PRIVATE));
  } else {
    dispatch(push(DEFAULT.RESTRICTED));
  }
};

export const initialNavigation = async (dispatch, getState) => {
  const { enteredUrl } = getState().auth;
  const { currentUser } = getState().auth;
  const { accounts } = getState().account;
  const { pathname } = getState().router.location;
  const { accountsError } = getState().account;
  const redirectURL = enteredUrl;
  if (!currentUser) {
    if (!PUBLIC_ROUTES.includes(pathname) && redirectURL && RESTRICTED.includes(redirectURL.pathname)) {
      await dispatch(authActions.setEnteredUrl(null));
      if (redirectURL) await dispatch(push(redirectURL));
      else navigateToDefaultRoute(dispatch, getState);
    }
  } else {
    await dispatch(authActions.setEnteredUrl(null));
    if (currentUser.updated_profile === false && currentUser.is_customer) {
      AlertHandler.info(message('ChangeUserInfo:warningMessage'));
      dispatch(push(ROUTES.CHANGE_USER_INFO));
    } else if (
      isEmpty(accounts) &&
      !accountsError &&
      appConfig.signUpFlow.AddAccount &&
      !appConfig.canUseDashboardWithoutAccounts
    ) {
      await dispatch(authActions.restartSignUp(6));
    } else if (redirectURL) await dispatch(push(redirectURL));
    else navigateToDefaultRoute(dispatch, getState);
  }
};
